import React from 'react';
import _ from 'lodash';

import { useShippingInformationWidgetQuery } from 'generated/graphql';



export interface IShipment {
  trackingNumber: string;
  trackingUrl: string;
  serviceCode: string;
  addrLine1: string;
  addrLine2: string;
  addrLine3: string;
}

export interface IData {
  shipments: IShipment[] | null;
}

export function useQuery(orderId: string) {
  const queryTuple = useShippingInformationWidgetQuery({
    variables: {
      orderId
    }
  });



  const wrappedTuple = React.useMemo(
    () => {
      const shipments = queryTuple.data?.orderLite?.shipment || [];
      const addr = queryTuple.data?.orderLite?.shippingAddress;

      const data: IData = {
        shipments: shipments.map(shipment => ({
          trackingUrl: shipment?.trackingUrl ?? '',
          serviceCode: shipment?.serviceCode ?? '',
          trackingNumber: shipment?.trackingNumber ?? '',
          addrLine1: addr?.street1 ?? '',
          addrLine2: addr?.street2 ?? '',
          addrLine3: addr ? _.join([
            addr.city,
            addr.usState,
            addr.postalCode
          ], ', ') : ''
        }))
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]
  );



  return wrappedTuple;
}
